import React from 'react';
import PaymentProviderPage from './components/payment-provider-page';

const Flitt = () => {
    return (
        <PaymentProviderPage
            provider="flitt"
            title="Flitt"
            fields={[
                { name: 'merchant_id', label: 'Merchant ID' },
                { name: 'secret_key', label: 'Secret Key', type: 'password' },
            ]}
        />
    );
};

export default Flitt;
